import {
    CARRIER as InsuranceFormCarrier,
    INSURANCE_TYPE as InsuranceFormInsuranceType,
} from '../InsuranceForm/constants';

import { REQUEST_CARRIERS_SUCCEEDED } from '../InsuranceForm/carriers';
import { REQUEST_PLANS_SUCCEEDED } from '../InsuranceForm/plans';
import { defineMessages } from 'react-intl';

export {
    ILL_CHOOSE_LATER_TEXT,
    IM_PAYING_MYSELF_TEXT,
} from '../InsuranceForm/constants';

export const InsuranceFormActions = {
    REQUEST_CARRIERS_SUCCEEDED,
    REQUEST_PLANS_SUCCEEDED,
};

export const ACTION_PREFIX = '@@insurance-picker';
export const AUTOCOMPLETE_SUCCESS = `${ACTION_PREFIX}/AUTOCOMPLETE_SUCCESS`;
export const AUTCOMPLETE_ERROR = `${ACTION_PREFIX}/AUTCOMPLETE_ERROR`;

export const KEYSTROKES = {
    ESCAPE: 27,
};

export const TAB = {
    INSURANCE: 1,
    PLAN: 2,
    BCBS: 3,
};

export const CARRIER = {
    ...InsuranceFormCarrier,
};

export const PLAN = {
    NO_PLAN_SELECTED: '-1',
};

export const INSURANCE_TYPE = {
    ...InsuranceFormInsuranceType,
};

export const COOKIE_MAPPING = {
    [InsuranceFormInsuranceType.HEALTH]: {
        carrier: 'hCarrierId',
        plan: 'hPlanId',
    },
    [InsuranceFormInsuranceType.DENTAL]: {
        carrier: 'dCarrierId',
        plan: 'dPlanId',
    },
    [InsuranceFormInsuranceType.VISION]: {
        carrier: 'vCarrierId',
        plan: 'vPlanId',
    },
};

export const ROOT_STATE_KEY = 'insurance-picker';
export const DROPDOWN_STATE_KEY = 'dropdownState';
export const FOCUS_COUNTER_KEY = 'focusCounter';
export const POPULAR_PLANS_BY_CARRIER_STATE_KEY = 'popularPlansByCarrier';

export const EVENT_INITIATOR = {
    USER: 'user',
};

export const INTERACTION_TYPE = {
    CLICK: 'click',
    TYPE: 'type',
};

export const COMPONENT_LOGGING_NAME = 'InsurancePicker';

export const LOCALIZED_STRINGS = defineMessages({
    FrontCaptureBoxText: {
        id: 'Components.InsurancePicker.ScanCardUpload.FrontCaptureBoxText',
        defaultMessage: 'Place your card on a flat surface, and tap to capture the front',
    },
    BackCaptureBoxText: {
        id: 'Components.InsurancePicker.ScanCardUpload.BackCaptureBoxText',
        defaultMessage: 'Now, flip your card over and tap to capture the back',
    },
});
